/* eslint-disable */
import React, { useState } from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import { Box, Flex, HStack, Text, Circle, Link as ChakraLink } from "@chakra-ui/react";
import { useSelector } from "react-redux";

const activeRoute = (routeName) => {
  const currentPath = window.location.pathname;
  const pathParts = currentPath.split('/'); // Split the pathname into parts
  return pathParts.includes(routeName);
  //const lastPart = pathParts[pathParts.length - 1]; // Get the last part of the path
  //return lastPart === routeName; // Check if the last part matches the routeName
};

const activeSubRoute = (subRoutes) => {
  let path = window.location.pathname.split("/");
  path = path[path.length - 1];
  return subRoutes.includes(path);
};

export function SidebarLinks(props) {
  const [toggle, setToggle] = useState({});
  const user = useSelector((state) => state?.user?.value);
  let privileges = user.hasOwnProperty("privileges") ? user.privileges : [];
  const { routes, onCloseSideMenu } = props;
  const handleToggle = (route) => {
    const updatedToggle = {};
    for (const toggleKey in toggle) {
      if (toggle.hasOwnProperty(toggleKey)) {
        updatedToggle[toggleKey] = toggleKey !== route ? false : toggle[toggleKey];
      }
    }
    // Update the state with the updatedToggle object
    setToggle(updatedToggle);
    setToggle((prevState) => ({
      ...prevState,
      [route]: !prevState[route], // Toggle the state of the submenu
    }));

  };

  return (
    <Box>
      {routes.map((route) => (
        <>
          {!route.collapse && (
            <NavItem key={route.name} route={route} privileges={privileges} handleToggle={handleToggle} onCloseSideMenu={onCloseSideMenu}>
              {route.name}
            </NavItem>
          )}

          {route.collapse && (
            <>
              <Box onClick={() => handleToggle(route.name)} cursor={'pointer'}>
                <ParentMenu
                  key={route.name}
                  route={route}
                  privileges={privileges}
                >
                  {route.name}
                </ParentMenu>
              </Box>
              <Box
                pl="3"
                pt="1"
                pb="2"
                width="100%"
                background="brand.500"
                borderRadius="5"
                display={toggle[route.name] ? "block" : "none"}
              >
                <SubMenu
                  onCloseSideMenu={onCloseSideMenu}
                  routes={route.items}
                  path={route.path}
                  privileges={privileges}
                />
              </Box>
            </>
          )}
        </>
      ))}
    </Box>
  )
}

const SubMenu = ({ routes, path, privileges, onCloseSideMenu }) => {
  return (
    <>
      {routes.map((route) => (
        <>
          {route.show && (
            <SubNavItem
              key={route.name}
              route={route}
              path={path}
              privileges={privileges}
              onCloseSideMenu={onCloseSideMenu}
            >
              {route.name}
            </SubNavItem>
          )}
        </>
      ))}
    </>
  );
};

const ParentMenu = ({ route, privileges, children }) => {
  const allowed = route.allow;
  const isRoleInArray = allowed.some(element => privileges.includes(element)) || allowed.some(element => ["all"].includes(element));
  return (
    <>
      {isRoleInArray && (
        <Box
          bg={(activeRoute(route.path.toLowerCase()) || (route.items && route.items.length > 0 && activeSubRoute(route.items))) ? "transparent" : "transparent"}
          borderRadius="5"
          mt="4"
          mb="4"
          cursor={'pointer'}
          color={(activeRoute(route.path.toLowerCase()) || (route.items && route.items.length > 0 && activeSubRoute(route.items))) ? "brand.500" : "#000000"}
        >
          {route.icon ? (
            <HStack
              spacing={(activeRoute(route.path.toLowerCase()) || (route.items && route.items.length > 0 && activeSubRoute(route.items))) ? "22px" : "22px"}
              py='5px'
              ps='10px'
              height="36px">
              <Flex w='100%' alignItems='center' justifyContent='center'>
                <Circle
                  background={(activeRoute(route.path.toLowerCase()) || (route.items && route.items.length > 0 && activeSubRoute(route.items))) ? "transparent" : "transparent"}
                  color={(activeRoute(route.path.toLowerCase()) || (route.items && route.items.length > 0 && activeSubRoute(route.items))) ? "brand.500" : "#000000"}
                  me='18px'
                  width="30px"
                  h="30px">
                  {route.icon}
                </Circle>
                <Text
                  me='auto'
                  fontSize={{ sm: "md", md: "lg" }}
                  color={(activeRoute(route.path.toLowerCase()) || (route.items && route.items.length > 0 && activeSubRoute(route.items))) ? "brand.500" : "#000000"}
                  fontWeight={
                    (activeRoute(route.path.toLowerCase()) || (route.items && route.items.length > 0 && activeSubRoute(route.items)))
                      ? "normal"
                      : "normal"
                  }
                  fontFamily="ManropeLight">
                  {route.name}
                </Text>
              </Flex>
            </HStack>
          ) : (
            <HStack
              spacing={
                (activeRoute(route.path.toLowerCase()) || (route.items && route.items.length > 0 && activeSubRoute(route.items))) ? "22px" : "22px"
              }
              py='5px'
              ps='10px'
              w='100%'>
              <Text
                me='auto'
                fontSize={{ sm: "md", md: "lg" }}
                color={(activeRoute(route.path.toLowerCase()) || (route.items && route.items.length > 0 && activeSubRoute(route.items))) ? "brand.500" : "#000000"}
                fontWeight={
                  (activeRoute(route.path.toLowerCase()) || (route.items && route.items.length > 0 && activeSubRoute(route.items)))
                    ? "bold"
                    : "normal"
                }>
                {route.name}
              </Text>
              <Box h='36px' w='4px' bg='transparent' borderRadius='5px' />
            </HStack>
          )}
        </Box>
      )}
    </>
  );
};

const SubNavItem = ({ route, path, privileges, onCloseSideMenu, children }) => {
  const allowed = route.allow;
  const isRoleInArray = allowed.some(element => privileges.includes(element)) || allowed.some(element => ["all"].includes(element));
  return (
    <>
      {isRoleInArray && (
        <ChakraLink
          as={ReactRouterLink}
          to={route.layout + "/" + path + "/" + route.path}
          onClick={onCloseSideMenu}
        >
          <Box
            pl="2"
            mt="2"
            mb="2"
            fontSize="17"
            color="#ffffff"
            textAlign="center"
          >
            {route.icon ? (
              <HStack
                spacing={
                  activeRoute(route.path.toLowerCase()) ? "22px" : "22px"
                }
                py='5px'
                ps='10px'
                w='100%'
                h='36px'>
                <Flex w='100%' alignItems='center' justifyContent='center'>
                  <Circle
                    color={activeRoute(route.path.toLowerCase()) ? "white" : "white"}
                    me='18px'
                    background={activeRoute(route.path.toLowerCase()) ? "transparent" : "transparent"}
                    width="30px"
                    h="30px"
                    fontWeight={activeRoute(route.path.toLowerCase()) ? "bold" : "normal"}>
                    {route.icon}
                  </Circle>
                  <Text
                    me='auto'
                    fontFamily="ManropeRegular"
                    fontSize={{ sm: "md", md: "lg" }}
                    color={activeRoute(route.path.toLowerCase()) ? "white" : "white"}
                    fontWeight={activeRoute(route.path.toLowerCase()) ? "bold" : "normal"}>
                    {route.name}
                  </Text>
                </Flex>
                <Box
                  h='36px'
                  w='4px'
                  bg={activeRoute(route.path.toLowerCase()) ? "transparent" : "transparent"}
                  borderRadius='5px'
                />
              </HStack>
            ) : (
              <HStack
                spacing={activeRoute(route.path.toLowerCase()) ? "22px" : "26px"}
                py='5px'
                ps='10px'
                w='100%'
                h='36px'>
                <Text
                  fontFamily="ManropeRegular"
                  fontSize={{ sm: "md", md: "lg" }}
                  me='auto'
                  color={activeRoute(route.path.toLowerCase()) ? "secondary.500" : "white"}
                  fontWeight={activeRoute(route.path.toLowerCase()) ? "bold" : "normal"}>
                  {route.name}
                </Text>
                <Box h='36px' w='4px' bg='transparent' borderRadius='5px' />
              </HStack>
            )}
          </Box>
        </ChakraLink>
      )}
    </>
  );
};

const NavItem = ({ route, privileges, handleToggle, onCloseSideMenu, children }) => {
  const allowed = route.allow;
  const isRoleInArray = allowed.some(element => privileges.includes(element)) || allowed.some(element => ["all"].includes(element));
  return (
    <>
      {isRoleInArray && (
        <ChakraLink
          as={ReactRouterLink}
          to={route.layout + "/" + route.path}
          cursor={'pointer'}
          onClick={onCloseSideMenu}
        >
          <Box onClick={() => handleToggle(route.name)} bg={(activeRoute(route.path.toLowerCase()) || (route.subRoutes && route.subRoutes.length > 0 && activeSubRoute(route.subRoutes))) ? "brand.500" : "transparent"}
            borderRadius="5" mb="3">
            {route.icon ? (
              <Box>
                <HStack
                  spacing={activeRoute(route.path.toLowerCase()) ? "22px" : "22px"}
                  py='5px'
                  ps='10px'>
                  <Flex w='100%' alignItems='center' justifyContent='center'>
                    <Circle
                      color={activeRoute(route.path.toLowerCase()) ? "#ffffff" : "#000000"}
                      me='18px'
                      width="30px"
                      h="30px">
                      {route.icon}
                    </Circle>
                    <Text
                      me='auto'
                      color={
                        activeRoute(route.path.toLowerCase())
                          ? "#ffffff" : "#000000"
                      }
                      fontWeight={
                        activeRoute(route.path.toLowerCase())
                          ? "bold" : "normal"
                      }
                      fontFamily="ManropeLight">
                      {route.name}
                    </Text>
                  </Flex>
                </HStack>
              </Box>
            ) : (
              <Box>
                <HStack
                  spacing={
                    activeRoute(route.path.toLowerCase()) ? "22px" : "22px"
                  }
                  py='5px'
                  ps='10px'>
                  <Text
                    me='auto'
                    color={
                      activeRoute(route.path.toLowerCase())
                        ? "#ffffff"
                        : "#000000"
                    }
                    fontWeight={
                      activeRoute(route.path.toLowerCase()) ? "bold" : "normal"
                    }>
                    {route.name}
                  </Text>
                  <Box h='36px' w='4px' bg='transparent' borderRadius='5px' />
                </HStack>
              </Box>
            )}
            {route.collapse ? <Box ml="50px">{(createLinks(route.items))}</Box> : ""}
          </Box>
        </ChakraLink>
      )}
    </>
  );
};

export default SidebarLinks;
